__turbopack_context__.v({
  "addStayButton": "NightsAdjuster-module__G4IEAq__addStayButton",
  "addStayText": "NightsAdjuster-module__G4IEAq__addStayText",
  "button": "NightsAdjuster-module__G4IEAq__button",
  "container": "NightsAdjuster-module__G4IEAq__container",
  "controls": "NightsAdjuster-module__G4IEAq__controls",
  "controlsAndLoader": "NightsAdjuster-module__G4IEAq__controlsAndLoader",
  "disabled": "NightsAdjuster-module__G4IEAq__disabled",
  "error": "NightsAdjuster-module__G4IEAq__error",
  "loadingDot": "NightsAdjuster-module__G4IEAq__loadingDot",
  "loadingIndicator": "NightsAdjuster-module__G4IEAq__loadingIndicator",
  "loadingPulse": "NightsAdjuster-module__G4IEAq__loadingPulse",
  "nightsDisplayContainer": "NightsAdjuster-module__G4IEAq__nightsDisplayContainer",
  "nightsLabel": "NightsAdjuster-module__G4IEAq__nightsLabel",
});
